var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-header-link",class:{
        'global-header-link--active': _vm.isActive,
    }},[_c('CustomRouterLink',{class:[
            'global-header-link__item',
            'sds-focus',
            {
                'global-header-link__item--active': _vm.isActive,
            },
            _vm.itemClasses ],attrs:{"dynamic":true,"destination":_vm.destination}},[_c('span',{staticClass:"global-header-link__label capitalize"},[_vm._v(_vm._s(_vm.$t(_vm.label)))]),(_vm.shouldLoadBadge && !_vm.badgeLabel)?_c('SdsContentLoader',{staticClass:"global-header-link__badge-loader",attrs:{"size":"xs"}}):(_vm.badgeLabel)?_c('SdsBadge',{attrs:{"background":"elevation","variant":"primary","styling":"danger","size":"md","shape":"pill"}},[_c('span',{staticClass:"global-header-link__badge"},[_vm._v(_vm._s(_vm.badgeLabel))])]):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }